import axios from '@/services/axios';
import type { AxiosRequestConfig } from 'axios';

/**
 * Non-CRUD business APIs should be placed here.
 * CRUD list/detail/add/edit/delete endpoints remain in crudApi.
 */
export function getGlobalConfig(config: AxiosRequestConfig = { cache: false, forceUpdate: true, notShowError: true }) {
  return axios.get('/common/option', config);
}

export default {
  getGlobalConfig,
};
